//
// Akkordeon
//

let akkordeonElement = document.querySelectorAll('.akkordeon');

let akkordeonToggle = document.querySelectorAll('.akkordeon-title');

let akkordeonHideClass = "state-hide";

let akkordeonShowClass = "state-show";

if (typeof (akkordeonElement) != 'undefined' && akkordeonElement != null) {
    akkordeonToggle.forEach(function (el) {
        el.addEventListener("click", function () {
            akkordeonTrigger(el);
        });
        el.addEventListener("keypress", function () {
            akkordeonTrigger(el);
        });
    });
}

function akkordeonTrigger(el) {
    let ariaState = el.parentNode.getAttribute("aria-expanded");

    if (ariaState === "false") {
        var children = [].slice.call(el.parentNode.children);

        children.forEach(function(element){
            element.parentNode.setAttribute("aria-expanded", "false");
            element.parentNode.classList.remove(akkordeonShowClass);
            element.parentNode.classList.add(akkordeonHideClass);
        });

        el.parentNode.setAttribute("aria-expanded", "true");
        el.parentNode.classList.remove(akkordeonHideClass);
        el.parentNode.classList.add(akkordeonShowClass);
    } else {
        el.parentNode.setAttribute("aria-expanded", "false");
        el.parentNode.classList.remove(akkordeonShowClass);
        el.parentNode.classList.add(akkordeonHideClass);
    }
}

export default {};
